import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { AppConfigService } from '../services/app-config.service';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

	constructor(private configService: AppConfigService) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const config = this.configService.getConfig();
		const token = localStorage.getItem('token');
		if (config !== undefined && token != null && (
			request.url.startsWith('/')
			|| request.url.startsWith(window.location.origin)
			|| request.url.startsWith(config.webApi)
			|| request.url.startsWith(config.webApi2))) {
				request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
		}
		return next.handle(request).pipe(
			tap({
				next: (httpResponse) => {
					if(httpResponse instanceof HttpResponse && httpResponse.status === 302) {
						window.location.href = '/identity/login';
					}
				},
				error: (httpErrorResponse) => {
					if (httpErrorResponse instanceof HttpErrorResponse && httpErrorResponse.url.includes('/Account/Login?')) {
							window.location.href = '/identity/login';
					}
				}
			})
		);
	}

	private shouldRedirectToLogin(): boolean {
		return false;
	}
}
